import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = {
  for: "category-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_6 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarUpload = _resolveComponent("AvatarUpload")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    title: _ctx.editModalTitle,
    opened: _ctx.opened,
    onHide: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_AvatarUpload, {
            modelValue: _ctx.editData.icon,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editData.icon) = $event)),
            placeholder: _ctx.editData.icon,
            size: "60x60",
            title: "Please, upload device icon.",
            onFileChanged: _ctx.fileUpload
          }, null, 8, ["modelValue", "placeholder", "onFileChanged"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_AppInput, {
            id: "question-title",
            modelValue: _ctx.editData.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.title) = $event)),
            "input-type": "material",
            label: "Title",
            type: "text",
            name: "question-title",
            "validation-type": "text"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SelectInput, {
              modelValue: _ctx.editData.brand,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.brand) = $event)),
              options: _ctx.brands,
              label: "Brand",
              size: "xl",
              class: "w-100",
              "validation-type": "value",
              onSelect: _ctx.selectBrandHandler
            }, null, 8, ["modelValue", "options", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _createVNode(_component_AppCheckbox, {
                id: "category-active",
                modelValue: _ctx.editData.active,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editData.active) = $event)),
                checked: _ctx.editData.active
              }, null, 8, ["modelValue", "checked"]),
              _hoisted_5
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AppButton, {
            disabled: !_ctx.valid,
            loading: _ctx.loading,
            type: "secondary",
            size: "xl",
            onClick: _ctx.addDevice
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.editData?.id ? "Edit" : "Add") + " Device ", 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "opened", "onHide"]))
}